module.exports = __webpack_public_path__ + "static/media/doorFilling.0b88b7a7.jpeg";